module.exports = __webpack_public_path__ + "static/media/cnbc-sept.5627f92a.jpg";